import { FC } from "react";
import ProductCategoryWebLayout from "./WebLayout";

const ProductCategory: FC = () => {
  return (
    <div>
      <ProductCategoryWebLayout />
    </div>
  );
};

export default ProductCategory;
